import React, { useState, useContext } from 'react'
import listContext from '../../../Common/context/context'
import updatePropertyList from '../../Utility/UpdatePropertyList/UpdatePropertyList'

const SelectRentCompView = () => {

    const { propertyList, setPropertyList } = useContext(listContext)
    const [settings, setSettings] = useState({
        marketRents: propertyList.marketRents,
        average: propertyList.average,
        highLow: propertyList.highLow,
        effectiveRents: propertyList.effectiveRents
    })

    function handleChange(val) {
        let marketRents = false, average = false, highLow = false, effectiveRents = false
        let fieldsToUpdate = []

        switch (val) {
            case 'effective':
                effectiveRents = true
                break
            case 'market':
                marketRents = true
                average = true
                break
            case 'both':
                effectiveRents = true
                average = true
                break
            case 'marketAverage':
                marketRents = true
                average = true
                break
            case 'marketHighLow':
                marketRents = true
                highLow = true
                break
            case 'effectiveAverage':
                effectiveRents = true
                average = true
                break
            case 'effectiveHighLow':
                effectiveRents = true
                highLow = true
                break
            default:
        }

        setSettings({ marketRents, average, highLow, effectiveRents })

        fieldsToUpdate.push({ key: 'compType', value: propertyList.compType })
        fieldsToUpdate.push({ key: 'marketRents', value: marketRents })
        fieldsToUpdate.push({ key: 'average', value: average })
        fieldsToUpdate.push({ key: 'highLow', value: highLow })
        fieldsToUpdate.push({ key: 'effectiveRents', value: effectiveRents })
        fieldsToUpdate.push({ key: 'polarisPropertySearchCriteriaId', value: propertyList.polarisPropertySearchCriteriaId })
        fieldsToUpdate.push({ key: 'omniViewPropertyListId', value: propertyList.omniViewPropertyListId })

        const updatePropertyListObj = new updatePropertyList(fieldsToUpdate)
        updatePropertyListObj.update()

        let newPropertyList = { ...propertyList }
        newPropertyList.marketRents = marketRents
        newPropertyList.average = average
        newPropertyList.highLow = highLow
        newPropertyList.effectiveRents = effectiveRents
        setPropertyList(newPropertyList)
    }

    const isChecked = target => {
        let returnVal = false

        switch (target) {
            case 'effective':
                returnVal = settings.effectiveRents && !settings.average && !settings.highLow ? true : false
                break
            case 'market':
                returnVal = !settings.effectiveRents ? true : false
                break
            case 'both':
                returnVal = settings.effectiveRents && (settings.average || settings.highLow) ? true : false
                break
            case 'marketAverage':
                returnVal = !settings.effectiveRents && settings.average ? true : false
                break
            case 'marketHighLow':
                returnVal = !settings.effectiveRents && settings.highLow ? true : false
                break
            case 'effectiveAverage':
                returnVal = settings.effectiveRents && settings.average ? true : false
                break
            case 'effectiveHighLow':
                returnVal = settings.effectiveRents && settings.highLow ? true : false
                break
            default:
        }

        return returnVal
    }

    function handleChkRenoDate() {
        let newPropertyList = { ...propertyList }
        newPropertyList.showReno = !newPropertyList.showReno
        setPropertyList(newPropertyList)
    }

    return (
        <>
            <div className="bg-white px-6 pt-6 pb-4">
                <div className="w-full">
                    <span className="font-medium form-control-lg">Rent Comps</span>
                </div>
                <div className="my-5 border-b-1 border-base">
                    <input data-testid='test-chk-reno-date' onChange={handleChkRenoDate} checked={propertyList.showReno} id="id-chk-reno-date" name="chk-reno-date" type="checkbox" />
                    <label onClick={handleChkRenoDate} className="px-3" htmlFor="chk-reno-date">Show renovated date</label>
                </div>
                <div>
                    <label>Unit mix rent data</label>
                </div>
                <div className="text-2 w-full flex flex-col py-4 space-y-7">

                    <div className="mt-2 flex flex-col space-y-4">
                        <div >
                            <button data-testid="test-button-market" onClick={() => { handleChange('market') }}
                                className={`btn border-base border-1 pl-3 pr-5 py-2 ${isChecked('market') ? 'bg-gray-10' : 'bg-white'}`}>
                                <span className="px-3">
                                    <input checked={isChecked('market')} type="radio"></input>
                                </span>
                                Market Rent
                            </button>
                        </div>
                        <div className="px-6 mt-2 flex flex-row space-x-6">
                            <div >
                                <button data-testid="test-button-marketAverage" disabled={!isChecked('market')} onClick={() => { handleChange('marketAverage') }}
                                    className={`btn border-base border-1 pl-3 pr-5 py-2 ${isChecked('marketAverage') ? 'bg-gray-10' : 'bg-white'}`}>
                                    <span className="px-3">
                                        <input checked={isChecked('marketAverage')} type="radio"></input>
                                    </span>
                                    Average
                                </button>
                            </div>
                            <div >
                                <button data-testid="test-button-marketHighLow" disabled={!isChecked('market')} onClick={() => { handleChange('marketHighLow') }}
                                    className={`btn border-base border-1 pl-3 pr-5 py-2 ${isChecked('marketHighLow') ? 'bg-gray-10' : 'bg-white'}`}>
                                    <span className="px-3">
                                        <input checked={isChecked('marketHighLow')} type="radio"></input>
                                    </span>
                                    High/Low
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="py-2">
                        <button data-testid="test-button-effective" onClick={() => { handleChange('effective') }}
                            className={`btn border-base border-1 pl-3 pr-5 py-2 ${isChecked('effective') ? 'bg-gray-10' : 'bg-white'}`}>
                            <span className="px-3">
                                <input checked={isChecked('effective')} type="radio"></input>
                            </span>
                            Effective Rent
                        </button>
                    </div>

                    <div className="mt-2 flex flex-col space-y-4">
                        <div >
                            <button data-testid="test-button-both" onClick={() => { handleChange('both') }}
                                className={`btn border-base border-1 pl-3 pr-5 py-2 ${isChecked('both') ? 'bg-gray-10' : 'bg-white'}`}>
                                <span className="px-3">
                                    <input checked={isChecked('both')} type="radio"></input>
                                </span>
                                Market and Effective Rent
                            </button>
                        </div>
                        <div className="px-6 mt-2 flex flex-row space-x-6">
                            <div >
                                <button data-testid="test-button-effectiveAverage" disabled={!isChecked('both')} onClick={() => { handleChange('effectiveAverage') }}
                                    className={`btn border-base border-1 pl-3 pr-5 py-2 ${isChecked('effectiveAverage') ? 'bg-gray-10' : 'bg-white'}`}>
                                    <span className="px-3">
                                        <input checked={isChecked('effectiveAverage')} type="radio"></input>
                                    </span>
                                    Average
                                </button>
                            </div>
                            <div >
                                <button data-testid="test-button-effectiveHighLow" disabled={!isChecked('both')} onClick={() => { handleChange('effectiveHighLow') }}
                                    className={`btn border-base border-1 pl-3 pr-5 py-2 ${isChecked('effectiveHighLow') ? 'bg-gray-10' : 'bg-white'}`}>
                                    <span className="px-3">
                                        <input checked={isChecked('effectiveHighLow')} type="radio"></input>
                                    </span>
                                    High/Low
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SelectRentCompView
